import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "gift_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M1 3h10.25v2.3A2.75 2.75 0 0 0 7.55 9H1V3Z" }),
      _createElementVNode("path", { d: "M10 9h1.25V7.75A1.25 1.25 0 1 0 10 9ZM3 10.5V21h8.25v-9.44l-2.97 2.97-1.06-1.06 2.97-2.97H3ZM12.75 11.56V21H21V10.5h-7.19l2.97 2.97-1.06 1.06-2.97-2.97ZM16.45 9H23V3H12.75v2.3a2.75 2.75 0 0 1 3.7 3.7Z" }),
      _createElementVNode("path", { d: "M12.75 7.75V9H14a1.25 1.25 0 1 0-1.25-1.25Z" })
    ], -1)
  ]))]))
}
export default { render: render }